import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ObjectSchema } from "yup";
import { useIntl } from "react-intl";
import { PageButtonLink, usePageData } from "../../../_metronic/layout/core";
import {
    ColGroupDef,
    ICellRendererParams,
    RowClassParams,
    RowModelType,
    RowNode,
    RowStyle,
    SelectionChangedEvent,
} from "ag-grid-community";
import { ColDef } from "ag-grid-community/dist/lib/entities/colDef";
import { SimpleEntityUpsertModal, SimpleEntityUpsertModalProps } from "./SimpleEntityUpsertModal";
import { AgGridReact } from "ag-grid-react";
import {
    SimpleEntityGridActionCell,
    SimpleEntityGridActionCellButton,
    SimpleEntityGridActionCellProps,
    TActionsConditions,
} from "./CellRenderer/SimpleEntityGridActionCell/SimpleEntityGridActionCell";
import {
    SimpleEntityGridExternalFilter,
    SimpleEntityGridExternalFilterProps,
} from "./SimpleEntityGridExternalFilter";
import { BaseAgGrid, ITransition, requestFilters } from "./BaseAgGrid";
import { toast } from "react-toastify";
import { ModalProps } from "react-bootstrap";
import moment from "moment";
import { SimpleEntityUpsertStepModal } from "./SimpleEntityUpsertStepModal";
import { find } from "lodash";
import { useLocation } from "react-router-dom";
import { SimpleEntityGridRest } from "./SimpleEntityGridRest";
import { IUpsertModal, IActionsModal } from "src/app/types/actionsModal";
import { exportServerSide } from "./GridHelpers";
export type SimpleEntityGridColumn = ColDef | ColGroupDef;

export type ToolbarButtonAction = {
    add?: boolean;
    export?: boolean;
    active?: boolean;
    metrics?: boolean;
    custom?: {
        action: (obj: any) => void;
        title: string;
        selectedRows?: boolean;
        singleSelectedRow?: boolean;
        condition?(ob: any): boolean;
        element?: React.FC<any>;
    }[];
};
type SimpleEntityGridProps = Pick<SimpleEntityUpsertModalProps, "saveHandler"> & {
    actions?: SimpleEntityGridActionCellButton[]; //array with all the row actions
    actionsConditions?: TActionsConditions;
    dataSourceLimit?: number;
    transition?: ITransition;
    actionsDisableConditions?: TActionsConditions;
    addAITitleAndPlanFormBodyContainer?: React.FC<IActionsModal<any>>;
    addUrlFormBodyContainer?: React.FC<IActionsModal<any>>; // body for AddUrl action
    approveFormBodyContainer?: React.FC<IActionsModal<any>>; // body for approve action
    asCellFilter?: boolean;
    chooseRDFormBodyContainer?: React.FC<IActionsModal<any>>; // body for chooseRDF action
    columns: Array<ColDef>; // columns to be display to agGrid
    conditionToUpdateTheGrid?(entity: any): boolean; // add a condition to force update agGrid data
    confirmationHandler?: (_values: any, objectId?: number) => any;
    confirmationModalBody?: React.FC<any>;
    confirmationModalCondition?: (values: any, entity?: any) => boolean;
    defaultFilters?: any; // default Filters
    disableWithConfirmationContainer?: React.FC<IActionsModal<any>>; // body for DisableWithConfirmation action
    disableWithConfirmationHandler?: (entity: any) => Promise<any>; // DB request to confirm data needed confirmation
    entityName: string; // name of the table
    formBody: React.FC<any>; // body form Edit and add data
    formTransformer?: (entity: any) => any; // function to convert data from dataBase to data we can Use in the form example - "thematic convert to thematicId"
    formType?: "simpleForm" | "stepForm"; // choose the form Type,
    formUpdateBody?: React.FC<any>; // form to update data, if not set, formBody is used by default
    getRowStyle?(params: RowClassParams<any>): RowStyle | undefined;
    indexMeFormBodyContainer?: React.FC<IActionsModal<any>>; //body for  indexMe action
    listHandler: (obj?: requestFilters) => any; // call to DB to get data for AGgrid
    exportHandler?: (obj?: requestFilters) => any; // call to DB to get excel file
    maxSteps?: number; // used in formType = "stepForm" to know the number of steps the current form has
    metricsHandler?(ids: number[]): Promise<void>; // DB call to Update Metrics
    modalProps?: { onSelected: ModalProps; onUnselected: ModalProps } | ModalProps; // Props for Modal,
    orderAsSendToUpdateGrid?(): any; // function are call when we orderToUpdateGrid.
    orderTextFormBodyContainer?: React.FC<IActionsModal<any>>; // body for orderText action
    orderToUpdateGrid?: boolean; // update agGrid
    rowModelType?: RowModelType; // to change type of rowModel, we are using "clientSide" or "serverSide"
    sendTextFormBodyContainer?: React.FC<IActionsModal<any>>; // body for chooseRDF action
    toggleActiveHandler?: (entity: any) => Promise<void>; // DB call to handle Toggle Action
    toolbarButtonAction?: ToolbarButtonAction; // to add toolbarButton to the toolbar default  {add: true, export: true, active: true}s
    totalFilteredHandle?: (obj?: requestFilters) => Promise<number>; // DB call to get the Total count of the filter data. ( only used in rowModelType = "serverSide")
    totalRowsHandle?: (obj?: object) => Promise<number>; // DB call to get the Total count of the data. ( only used in rowModelType = "serverSide")
    validationSchema: ObjectSchema<any>; // Schema to validate form in  formBody and formUpdateBody
    verifyFormBodyContainer?: React.FC<IActionsModal<any>>; // body for Verify action
    viewTextFormBodyContainer?: React.FC<IActionsModal<any>>; // body for viewText action
    waitingFormBodyContainer?: React.FC<IActionsModal<any>>; // body for waiting action
    metricsFormBodyContainer?: React.FC<any>; // body for metrics
    removeRDFormBodyContainer?: React.FC<IActionsModal<any>>; // body to remove RD
    addAITitleFormBodyContainer?: React.FC<IActionsModal<any>>; // body to remove RD
    addAIPlanFormBodyContainer?: React.FC<IActionsModal<any>>; // body to remove RD
    planningsFormBodyContainer?: React.FC<IActionsModal<any>>; // body to remove RD
    AIGuideFormBodyContainer?: React.FC<IActionsModal<any>>; // body to remove RD
    CreateCampaignFormBodyContainer?: React.FC<IActionsModal<any>>; // create a campaign
    CreatePopCashCampaignFormBodyContainer?: React.FC<IActionsModal<any>>; // create a campaign
    wordpressAccessFormBodyContainer?: React.FC<IActionsModal<any>>; // body to remove RD
    sendPersonaFormBodyContainer?: React.FC<IActionsModal<any>>; // body for persona action
    siloFormBodyContainer?: React.FC<IActionsModal<any>>; // body to handle silo
    NetlinkingFormBodyContainer?: React.FC<IActionsModal<any>>; // body to handle silo
    UpsertFormBodyContainer?: React.FC<IUpsertModal<any>>; // body upsert form
    submitByStepsBody?: React.FC<{ upsertData: any; enableCloseButton(): void }>; // body to handle silo
};

export const SimpleEntityGrid: React.FC<SimpleEntityGridProps> = (props) => {
    const {
        actions,
        actionsConditions,
        dataSourceLimit,
        actionsDisableConditions,
        asCellFilter,
        addAITitleAndPlanFormBodyContainer = () => <></>,
        totalFilteredHandle,
        defaultFilters,
        transition,
        totalRowsHandle,
        addUrlFormBodyContainer = () => <></>,
        chooseRDFormBodyContainer = () => <></>,
        verifyFormBodyContainer = () => <></>,
        approveFormBodyContainer = () => <></>,
        orderTextFormBodyContainer = () => <></>,
        indexMeFormBodyContainer = () => <></>,
        addAITitleFormBodyContainer = () => <></>,
        planningsFormBodyContainer = () => <></>,
        addAIPlanFormBodyContainer = () => <></>,
        wordpressAccessFormBodyContainer = () => <></>,
        AIGuideFormBodyContainer = () => <></>,
        siloFormBodyContainer = () => <></>,
        NetlinkingFormBodyContainer = () => <></>,
        UpsertFormBodyContainer,
        CreateCampaignFormBodyContainer = () => <></>,
        CreatePopCashCampaignFormBodyContainer = () => <></>,
        metricsFormBodyContainer,
        submitByStepsBody,
        columns: gridColumns,
        confirmationHandler,
        confirmationModalBody,
        confirmationModalCondition,
        entityName,
        formBody,
        formTransformer,
        conditionToUpdateTheGrid,
        formType = "simpleForm",
        formUpdateBody,
        listHandler,
        exportHandler,
        maxSteps = 0,
        metricsHandler,
        modalProps,
        orderAsSendToUpdateGrid = () => {},
        saveHandler,
        sendTextFormBodyContainer = () => <></>,
        sendPersonaFormBodyContainer = () => <></>,
        removeRDFormBodyContainer = () => <></>,
        toggleActiveHandler,
        rowModelType,
        toolbarButtonAction = {
            add: true,
            export: true,
            active: true,
            metrics: false,
        },
        validationSchema,
        getRowStyle,
        orderToUpdateGrid,
        viewTextFormBodyContainer = () => <></>,
        waitingFormBodyContainer = () => <></>,
        disableWithConfirmationContainer = () => <></>,
        disableWithConfirmationHandler = undefined,
    } = props;
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [selectedRows, setSelectedRows] = useState<Array<any>>([]);
    const [actionType, setActionType] = useState<SimpleEntityGridActionCellButton>("");
    const [showModal, setShowModal] = useState(false);
    const [showMetrics, setShowMetrics] = useState(false);

    const gridRef = useRef<AgGridReact>(null);

    const { formatMessage } = useIntl();
    const { pageTitle, setPageTitle, setPageToolbarButtons } = usePageData();
    const location = useLocation();

    let showActive = true;

    const updateGridOnSave = async (_entity: any, isNew?: boolean, removeRow?: boolean) => {
        const gridApi = gridRef?.current?.api;
        if (!isNew) {
            if (conditionToUpdateTheGrid && conditionToUpdateTheGrid(_entity)) {
                gridApi?.setRowData(await listHandler());
            } else {
                const node = gridApi?.getRowNode(_entity.id.toString());
                if (!removeRow) {
                    node?.setData(_entity);
                } else {
                    gridApi?.applyTransaction({ remove: [_entity] });
                }
            }
        } else {
            if (rowModelType === "serverSide") {
                gridApi?.refreshServerSide();
            } else {
                gridApi?.setRowData(await listHandler());
            }
            gridApi?.setColumnDefs(gridColumns);
            gridApi?.deselectAll();
        }
    };
    const resetGrid = () => {
        gridRef?.current?.api.setFilterModel({});
        gridRef?.current?.columnApi.resetColumnState();
        window.localStorage.removeItem(`${location.pathname}`);
    };

    const externalFilterChanged = useCallback((currentTitle?: string) => {
        showActive = !showActive;

        if (
            !showActive &&
            !currentTitle?.includes(`(${formatMessage({ id: "common.title.inactive" })})`)
        )
            setPageTitle(`${currentTitle}(${formatMessage({ id: "common.title.inactive" })})`);

        if (
            showActive &&
            currentTitle?.includes(`(${formatMessage({ id: "common.title.inactive" })})`)
        )
            setPageTitle(
                `${currentTitle?.replace(
                    `(${formatMessage({ id: "common.title.inactive" })})`,
                    ""
                )}`
            );

        gridRef?.current?.api.onFilterChanged();
    }, []);

    const onSelectionChanged = (event: SelectionChangedEvent) => {
        setSelectedRows(event.api.getSelectedRows());
    };

    const metricUpdate = async () => {
        if (metricsFormBodyContainer) {
            setShowMetrics(true);
            return;
        }
        if (!metricsHandler) return;
        try {
            await metricsHandler(selectedRows.map((item: any) => item.id));
            toast.success(formatMessage({ id: "common.notification.success" }));
            gridRef?.current?.api.deselectAll();
            setSelectedRows([]);
            updateGridOnSave([], true);
        } catch (error: any) {
            toast.error(formatMessage({ id: "common.notification.error" }));
        }
    };

    const getGridToolbarButtons = () => {
        const currentPageToolbarButtons: Array<PageButtonLink> = [];
        if (
            selectedRows &&
            toolbarButtonAction.metrics &&
            selectedRows.length > 0 &&
            (metricsHandler != undefined || metricsFormBodyContainer != undefined) &&
            !find(selectedRows, { active: false })
        )
            currentPageToolbarButtons.push({
                path: "#",
                title: `${formatMessage({ id: "common.action.update_metrics" })}`,
                onClick: metricUpdate,
            });

        if (toolbarButtonAction.custom?.length) {
            toolbarButtonAction.custom.forEach((custom) => {
                if (
                    ((custom.condition && custom.condition(selectedRows)) || !custom.condition) &&
                    ((selectedRows.length > 0 && custom.selectedRows == true) ||
                        (!custom.selectedRows && !custom.singleSelectedRow) ||
                        (selectedRows.length == 1 && custom?.singleSelectedRow == true))
                ) {
                    currentPageToolbarButtons.push({
                        path: "#",
                        title: custom.title,
                        onClick: () => {
                            custom?.action({ selectedRows, updateGridOnSave });
                        },
                        renderComponent: custom.element
                            ? () =>
                                  !!custom.element ? (
                                      React.createElement(custom.element, { updateGridOnSave })
                                  ) : (
                                      <></>
                                  )
                            : undefined,
                    });
                }
            });
        }

        if (toolbarButtonAction.export) {
            const date = moment().format("YYYY-MM-DD");
            const pageTitleNoSpace = pageTitle?.replace(" ", "_");
            const currentFileName = `${pageTitleNoSpace} _${date}`;
            currentPageToolbarButtons.push({
                path: "#",
                title: `${formatMessage({ id: "common.action.export" })}`,
                onClick: async () => {
                    if (exportHandler) {
                        const sortModal: Array<any> = [];
                        gridRef.current?.columnApi.getColumnState().forEach((el) => {
                            if (el.sort) {
                                sortModal.push({ colId: el.colId, sort: el.sort });
                            }
                        });
                        const params = {
                            filterModel: gridRef.current?.api.getFilterModel(),
                            sortModal,
                        };
                        const data = await exportHandler(params);
                        exportServerSide(data, currentFileName);
                    } else {
                        gridRef?.current?.api.exportDataAsExcel({
                            fileName: currentFileName,
                            sheetName: pageTitleNoSpace,
                        });
                    }
                },
            });
        }

        if (toolbarButtonAction.add)
            currentPageToolbarButtons.push({
                path: "#",
                title: `${formatMessage({ id: "common.action.add" })}`,
                onClick: () => {
                    setSelectedEntity(null);
                    setShowModal(true);
                },
            });
        if (toolbarButtonAction.active)
            currentPageToolbarButtons.push({
                path: "#",
                title: ``,
                renderComponent: SimpleEntityGridExternalFilter,
                renderComponentProps: {
                    onChange: externalFilterChanged,
                } as SimpleEntityGridExternalFilterProps,
            });

        currentPageToolbarButtons.push({
            path: "#",
            title: ``,
            renderComponent: SimpleEntityGridRest,
            renderComponentProps: {
                onChange: resetGrid,
            } as SimpleEntityGridExternalFilterProps,
        });

        return currentPageToolbarButtons;
    };

    const toggleActive = async (data: any) => {
        if (!toggleActiveHandler) return;
        try {
            await toggleActiveHandler(data);
            data.active = !data.active;
            await updateGridOnSave(data, false);
            toast.success(formatMessage({ id: "common.notification.success" }));
            externalFilterChanged(pageTitle);
        } catch {
            toast.error(formatMessage({ id: "common.notification.error" }));
        }
    };

    if (actions && actions.length > 0 && !gridColumns.find((row) => row.field === "actions")) {
        // numberOfActions * sizeOfActionButton + 2 * padding + border
        const width = actions?.length * 33.25 + 2 * 11 + 1;
        gridColumns.push({
            field: "actions",
            lockPosition: "right",
            sortable: false,
            filter: false,
            minWidth: width,
            maxWidth: width,
            pinned: "right",
            cellRenderer: SimpleEntityGridActionCell,
            cellRendererParams: ({
                data,
            }: ICellRendererParams): SimpleEntityGridActionCellProps => ({
                data,
                actions,
                actionsConditions,
                actionsDisableConditions,
                onClick: async (button: SimpleEntityGridActionCellButton) => {
                    if (button === "edit") {
                        setSelectedEntity(data);
                        setShowModal(true);
                    } else if (button === "disable" || button === "enable") {
                        await toggleActive(data);
                    } else if (button === "sendText") {
                        setSelectedEntity(data);
                        setActionType("sendText");
                    } else if (button === "viewText") {
                        setActionType("viewText");
                        setSelectedEntity(data);
                    } else if (button === "chooseRD") {
                        setActionType("chooseRD");
                        setSelectedEntity(data);
                    } else if (button === "waiting") {
                        setActionType("waiting");
                        setSelectedEntity(data);
                    } else if (button === "addUrl") {
                        setActionType("addUrl");
                        setSelectedEntity(data);
                    } else if (button === "disableWithConfirmation") {
                        setActionType("disableWithConfirmation");
                    } else if (button === "verified") {
                        setActionType("verified");
                        setSelectedEntity(data);
                    } else if (button === "approve") {
                        setActionType("approve");
                        setSelectedEntity(data);
                    } else if (button === "orderText") {
                        setActionType("orderText");
                        setSelectedEntity(data);
                    } else if (button === "indexMe") {
                        setActionType("indexMe");
                        setSelectedEntity(data);
                    } else if (button === "addAITitle") {
                        setActionType("addAITitle");
                        setSelectedEntity(data);
                    } else if (button === "addAIPlan") {
                        setActionType("addAIPlan");
                        setSelectedEntity(data);
                    } else if (button === "addAITitleAndPlan") {
                        setActionType("addAITitleAndPlan");
                        setSelectedEntity(data);
                    } else if (button === "removeRD") {
                        setActionType("removeRD");
                        setSelectedEntity(data);
                    } else if (button === "plannings") {
                        setActionType("plannings");
                        setSelectedEntity(data);
                    } else if (button === "silo") {
                        setActionType("silo");
                        setSelectedEntity(data);
                    } else if (button === "netlinking") {
                        setActionType("netlinking");
                        setSelectedEntity(data);
                    } else if (button === "wordpressAccess") {
                        setActionType("wordpressAccess");
                        setSelectedEntity(data);
                    } else if (button === "AIGuide") {
                        setActionType("AIGuide");
                        setSelectedEntity(data);
                    } else if (button === "createCampaign") {
                        setActionType("createCampaign");
                        setSelectedEntity(data);
                    } else if (button === "createPopcashCampaign") {
                        setActionType("createPopcashCampaign");
                        setSelectedEntity(data);
                    } else if (button === "editPersona") {
                        setActionType("editPersona");
                        setSelectedEntity(data);
                    }
                },
            }),
        });
    }

    // Example load data from sever
    useEffect(() => {
        setPageToolbarButtons(getGridToolbarButtons());
    }, [selectedEntity, pageTitle, selectedRows]);

    useEffect(() => {
        if (orderToUpdateGrid) {
            updateGridOnSave({}, true);
            orderAsSendToUpdateGrid();
        }
    }, [orderToUpdateGrid]);

    const doesExternalFilterPass = useCallback(
        (node: RowNode): boolean => {
            if (node.data) {
                return showActive == node.data.active;
            }
            return true;
        },
        [showActive]
    );

    return (
        <>
            {!selectedEntity ? (
                {
                    simpleForm: (
                        <>
                            {UpsertFormBodyContainer && selectedEntity ? (
                                <UpsertFormBodyContainer
                                    updateGridOnSave={updateGridOnSave}
                                    showModal={showModal}
                                    entity={selectedEntity}
                                    handleClose={() => setShowModal(false)}
                                />
                            ) : (
                                <SimpleEntityUpsertModal
                                    showModal={showModal}
                                    entityName={entityName}
                                    entity={selectedEntity}
                                    handleClose={() => setShowModal(false)}
                                    updateGridOnSave={updateGridOnSave}
                                    saveHandler={saveHandler}
                                    validationSchema={validationSchema}
                                    modalProps={
                                        modalProps?.onSelected ? modalProps?.onSelected : modalProps
                                    }
                                    confirmationHandler={confirmationHandler}
                                    confirmationModalBody={confirmationModalBody}
                                    confirmationModalCondition={confirmationModalCondition}
                                    formTransformer={formTransformer}
                                >
                                    {formUpdateBody
                                        ? React.createElement(formUpdateBody)
                                        : React.createElement(formBody)}
                                </SimpleEntityUpsertModal>
                            )}
                        </>
                    ),
                    stepForm: (
                        <SimpleEntityUpsertStepModal
                            showModal={showModal}
                            entityName={entityName}
                            entity={selectedEntity}
                            handleClose={() => setShowModal(false)}
                            updateGridOnSave={updateGridOnSave}
                            saveHandler={saveHandler}
                            modalProps={
                                modalProps?.onSelected ? modalProps?.onSelected : modalProps
                            }
                            maxSteps={maxSteps}
                            confirmationHandler={confirmationHandler}
                            confirmationModalBody={confirmationModalBody}
                            confirmationModalCondition={confirmationModalCondition}
                            submitByStepsBody={submitByStepsBody}
                        >
                            {formUpdateBody && selectedEntity
                                ? React.createElement(formUpdateBody, { entity: selectedEntity })
                                : React.createElement(formBody, {
                                      entity: selectedEntity,
                                      maxSteps,
                                  })}
                        </SimpleEntityUpsertStepModal>
                    ),
                }[formType]
            ) : (
                <>
                    {UpsertFormBodyContainer && selectedEntity ? (
                        <UpsertFormBodyContainer
                            updateGridOnSave={updateGridOnSave}
                            showModal={showModal}
                            entity={selectedEntity}
                            handleClose={() => setShowModal(false)}
                        />
                    ) : (
                        <SimpleEntityUpsertModal
                            showModal={showModal}
                            entityName={entityName}
                            entity={selectedEntity}
                            handleClose={() => setShowModal(false)}
                            updateGridOnSave={updateGridOnSave}
                            saveHandler={saveHandler}
                            validationSchema={validationSchema}
                            modalProps={
                                modalProps?.onUnselected ? modalProps?.onUnselected : modalProps
                            }
                            confirmationHandler={confirmationHandler}
                            confirmationModalBody={confirmationModalBody}
                            confirmationModalCondition={confirmationModalCondition}
                            formTransformer={formTransformer}
                        >
                            {formUpdateBody
                                ? React.createElement(formUpdateBody, { entity: selectedEntity })
                                : React.createElement(formBody, {
                                      entity: selectedEntity,
                                  })}
                        </SimpleEntityUpsertModal>
                    )}
                </>
            )}

            {
                {
                    edit: <></>,
                    disable: <></>,
                    enable: <></>,
                    sendText: React.createElement(sendTextFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    editPersona: React.createElement(sendPersonaFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    wordpressAccess: React.createElement(wordpressAccessFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    viewText: React.createElement(viewTextFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    chooseRD: React.createElement(chooseRDFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    waiting: React.createElement(waitingFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    addUrl: React.createElement(addUrlFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    disableWithConfirmation: React.createElement(disableWithConfirmationContainer, {
                        handleClose: () => setActionType(""),
                        entity: selectedEntity,
                        disableWithConfirmationHandler,
                        toggleActiveHandler: () => toggleActive(selectedEntity),
                    }),
                    verified: React.createElement(verifyFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    approve: React.createElement(approveFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    orderText: React.createElement(orderTextFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    indexMe: React.createElement(indexMeFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    addAITitleAndPlan: React.createElement(addAITitleAndPlanFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    addAITitle: React.createElement(addAITitleFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    addAIPlan: React.createElement(addAIPlanFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    removeRD: React.createElement(removeRDFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    plannings: React.createElement(planningsFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    silo: React.createElement(siloFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    AIGuide: React.createElement(AIGuideFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    createCampaign: React.createElement(CreateCampaignFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    netlinking: React.createElement(NetlinkingFormBodyContainer, {
                        handleClose: () => setActionType(""),
                        updateGridOnSave,
                        entity: selectedEntity,
                    }),
                    createPopcashCampaign: React.createElement(
                        CreatePopCashCampaignFormBodyContainer,
                        {
                            handleClose: () => setActionType(""),
                            updateGridOnSave,
                            entity: selectedEntity,
                        }
                    ),
                    "": <></>,
                }[actionType]
            }

            {metricsFormBodyContainer &&
                showMetrics &&
                React.createElement(metricsFormBodyContainer, {
                    entities: selectedRows,
                    handleClose: () => setShowMetrics(false),
                })}

            {useMemo(
                () => (
                    <div className="ag-theme-balham" style={{ height: "100%" }}>
                        <BaseAgGrid
                            listHandler={(params) =>
                                listHandler({ isActive: showActive ? 1 : 0, ...params })
                            }
                            asCellFilter={asCellFilter}
                            rowModelType={rowModelType}
                            totalFilteredHandle={
                                totalFilteredHandle &&
                                ((params) =>
                                    totalFilteredHandle({
                                        isActive: showActive ? 1 : 0,
                                        ...params,
                                    }))
                            }
                            totalRowsHandle={
                                totalRowsHandle &&
                                ((params) =>
                                    totalRowsHandle({ isActive: showActive ? 1 : 0, ...params }))
                            }
                            dataSourceLimit={dataSourceLimit}
                            gridRef={gridRef}
                            transition={transition}
                            defaultFilters={defaultFilters}
                            columnDefs={gridColumns}
                            isExternalFilterPresent={() => true}
                            doesExternalFilterPass={doesExternalFilterPass}
                            onSelectionChanged={onSelectionChanged}
                            getRowStyle={getRowStyle}
                        />
                    </div>
                ),
                []
            )}
        </>
    );
};
